import { render, staticRenderFns } from "./SensitiveKeywordsLogList.vue?vue&type=template&id=dc15df40&scoped=true"
import script from "./SensitiveKeywordsLogList.vue?vue&type=script&lang=js"
export * from "./SensitiveKeywordsLogList.vue?vue&type=script&lang=js"
import style0 from "./SensitiveKeywordsLogList.vue?vue&type=style&index=0&id=dc15df40&prod&lang=scss&scoped=true"
import style1 from "./SensitiveKeywordsLogList.vue?vue&type=style&index=1&id=dc15df40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc15df40",
  null
  
)

export default component.exports